module.exports = __webpack_public_path__ + "img/1 (17).c599ba11.png";